const csvTemplate = {
  rows: [
    ['32ab472c87965404fc9bc12dfdb4e032929645ff6cd271d3e965907482dadd54'],
    ['4464f3a3cdc34aa0a948feea689cd60f4667e1b40415abaa34f300c53164176b'],
    ['20807dc1b9e4799667d689925c9b15787c99bc63fe4a9fdb978e5ca01cdc63e4'],
    ['8f3a6d2e1c5b4a9f7e8d3c2b1a0f9e8d7c6b5a4f3e2d1c0b9a8f7e6d5c4b3a21'],
    ['7e2d1c0b9a8f7e6d5c4b3a2198f7e6d5c4b3a2107f6e5d4c3b2a190e5d4c3b2a1'],
    ['9f8e7d6c5b4a3f2e1d0c9b8a7f6e5d4c3b2a1f0e9d8c7b6a5f4e3d2c1b0a9f8e7'],
  ],
  templateName: 'Lookalike Audience Template',
};

export const LookalikeConfig = {
  csvTemplate,
};
